export default __webpack_public_path__ + "static/media/DanskeNarrow-Italic.ce5d8699.woff";